<template>
  <div>
    <div v-if="$auth.policies['view-tuition-fee-debt']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Quản lý công nợ"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: 'Quản lý công nợ', href: '#' },
            ]"
          />
        </div>
        <ExportExcel />
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <DebtFilter />
      </v-card>
      <v-card outlined class="mx-4 mb-6 elevation-0">
        <TableStudentDebt />
      </v-card>
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
  </div>
</template>
<script>
import Page403 from '@/views/Page403.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import DebtFilter from '../../modules/tuitionFee/debt-manager/DebtFilter.vue'
import TableStudentDebt from '../../modules/tuitionFee/debt-manager/TableStudentDebt.vue'
import ExportExcel from '../../modules/tuitionFee/debt-manager/ExportExcel.vue'
export default {
  components: {
    Page403,
    Breadcrumbs,
    DebtFilter,
    TableStudentDebt,
    ExportExcel,
  },
  computed: {},
  methods: {},
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
